// QA_CheckListForm.js - Main component file
import React, { useState } from "react";

// Import tab components as default exports
import CategoriesTab from "./categoriesTab";
import QuestionTypesTab from "./questionTypesTab";
import OptionsTab from "./optionsTab";
import QuestionsTab from "./questionsTab";
import FormTemplatesTab from "./formTemplatesTab";
import FormSubmissionsTab from "./formSubmissionsTab";
import PreviewTab from "./previewTab";
import AssignmentTab from "./assignmentTab";

function QA_CheckListForm() {
  // State for active tab
  const [activeTab, setActiveTab] = useState("categories");

  // Tab configurations
  const tabs = [
    { id: "categories", label: "Categories", icon: "fas fa-tags" },
    {
      id: "question-types",
      label: "Question Types",
      icon: "fas fa-question-circle",
    },
    { id: "questions", label: "Questions", icon: "fas fa-question" },
    { id: "options", label: "Options", icon: "fas fa-list-check" },
    { id: "form-templates", label: "Form Templates", icon: "fas fa-file-alt" },
    {
      id: "assign-templates",
      label: "Assign Templates",
      icon: "fas fa-link",
    },
    // {
    //   id: "form-submissions",
    //   label: "Form Submissions",
    //   icon: "fas fa-file-upload",
    // },
    // { id: "preview", label: "Preview", icon: "fas fa-eye" },
  ];

  // Function to render the active tab content
  const renderActiveTab = () => {
    switch (activeTab) {
      case "categories":
        return <CategoriesTab />;
      case "question-types":
        return <QuestionTypesTab />;
      case "questions":
        return <QuestionsTab />;
      case "options":
        return <OptionsTab />;
      case "form-templates":
        return <FormTemplatesTab />;
      case "assign-templates":
        return <AssignmentTab />;
      // case "form-submissions":
      //   return <FormSubmissionsTab />;
      // case "preview":
      //   return <PreviewTab />;
      default:
        return <CategoriesTab />;
    }
  };

  return (
    <>
      <div className="page-header d-flex mb-2">
        <h2 className="page-heading mb-2 fs-7">QA Checklist Form Management</h2>
      </div>

      {/* Tab Navigation */}
      <div className="card mb-3">
        <div className="card-body p-2">
          <ul
            className="nav nav-tabs nav-tabs-custom"
            id="qaTabs"
            role="tablist"
          >
            {tabs.map((tab) => (
              <li className="nav-item" key={tab.id}>
                <button
                  className={`nav-link ${activeTab === tab.id ? "active" : ""}`}
                  onClick={() => setActiveTab(tab.id)}
                  type="button"
                  role="tab"
                >
                  <i className={tab.icon}></i> {tab.label}
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* Tab Content */}
      <div className="tab-content" id="qaTabContent">
        {renderActiveTab()}
      </div>
    </>
  );
}

export default QA_CheckListForm;
